import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

/**
 * This is the style class for SummaryPageProductList.
 */
export default class SummaryPageProductListStyle {
	/**
	 * Returns styles.
	 *
	 * @param options ...
	 * @param options.theme ...
	 * @param options.showAvailabilityOptions ...
	 */
	public static getStyle(options: { theme: ITheme; showAvailabilityOptions: boolean }): string {
		const { spacing, breakpoint } = options.theme;
		const { showAvailabilityOptions } = options;
		if (showAvailabilityOptions) {
			return css`
				.header {
					display: flex;
					flex-direction: column;
					gap: ${spacing.space200 / 16}rem;
					margin-bottom: ${spacing.space250 / 16}rem;
				}

				.availability {
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					justify-content: center;
					gap: ${spacing.space100 / 16}rem;
				}

				@media (min-width: ${breakpoint.medium.width / 16}rem) {
					.header {
						display: grid;
						grid-auto-flow: row;
						grid-template-columns: repeat(2, auto);
						gap: ${spacing.space100 / 16}rem;
					}

					.availability {
						display: flex;
						flex-direction: column;
						align-items: flex-start;
						justify-content: center;
						gap: ${spacing.space100 / 16}rem;
					}

					kompis-sort-list {
						place-self: end end;
					}
				}

				@media (min-width: ${breakpoint.xlarge.width / 16}rem) {
					.header {
						gap: ${spacing.space150 / 16}rem;
					}

					.availability {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: flex-start;
						flex-wrap: wrap;
						column-gap: ${spacing.space150 / 16}rem;
						row-gap: ${spacing.space100 / 16}rem;
					}
				}

				${this.getCommonStyle()}
			`;
		} else {
			/**
			 * We don't want any gaps after the availability container when there are no availability options (the container is hidden).
			 *
			 * This is why there is separate styling for this case. The grid/flex gap can't be hidden through css.
			 */
			return css`
				.header {
					margin-bottom: ${spacing.space250 / 16}rem;
				}

				@media (min-width: ${breakpoint.medium.width / 16}rem) {
					.header {
						display: flex;
						justify-content: flex-end;
					}
				}

				${this.getCommonStyle()}
			`;
		}
	}

	/**
	 * Returns common styles.
	 *
	 */
	private static getCommonStyle(): string {
		return css`
			@media print {
				.header {
					display: none;
				}
			}
		`;
	}
}
